module.exports = __webpack_public_path__ + "static/media/ips-wallet.67a197a2.svg";